import { useCallback, useContext } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import {
  Link as DSLink,
  Icon,
  Item,
  Listbox,
  Span,
} from "@icg360/design-system";

import { AuthAppContext } from "components/root/auth-app-provider";
import { useNavItems } from "hooks/useNavItems";

import styles from "./mobile-nav-menu.module.scss";

type MobileNavMenuProps = {
  onClose: () => void;
  onPolicySelector: () => void;
};

export const MobileNavMenu = ({
  onClose,
  onPolicySelector,
}: MobileNavMenuProps) => {
  const navigate = useNavigate();
  const { selectedPolicyId, userDetails } = useContext(AuthAppContext);
  const { pathname } = useLocation();

  const navItems = useNavItems();

  const onSelectionChange = useCallback(
    (selection: Set<string>) => {
      onClose();
      const path = selection.keys().next().value;
      navigate(path);
    },
    [navigate, onClose]
  );

  return (
    <div className={styles.wrapper}>
      <div>
        <button
          className={styles.currentPolicyBtn}
          onClick={onPolicySelector}
          data-testid="mobile-policy-select-btn"
        >
          <Span bold>{userDetails?.propertyAddress?.street1}</Span>
          {userDetails?.propertyAddress?.street2 ? (
            <Span bold>{userDetails?.propertyAddress?.street2}</Span>
          ) : null}
          <Span>{`(Policy #${selectedPolicyId})`}</Span>
          <DSLink className={styles.switchLinkDS}>
            Switch to a different policy
          </DSLink>
        </button>
        <Listbox
          items={navItems}
          className={styles.navBoxDS}
          selectedKeys={new Set([pathname])}
          selectionMode="single"
          onSelectionChange={onSelectionChange}
          aria-label="main navigation"
        >
          {({ to, title, iconName }) => (
            <Item key={to} textValue={title.toLowerCase()}>
              <div className={styles.navItem}>
                <Icon name={iconName} />
                {title}
              </div>
            </Item>
          )}
        </Listbox>
      </div>
    </div>
  );
};
